import Auth from "@system/config/auth";
import { isArray, isObject } from "underscore";
import Cookies from "js-cookie";
import HCLDX from "@system/config/hcldx";
import { toast } from "react-toastify";
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import Helper from "../support/Helper";
import Constants from "src/support/Constants";
import liveAuth from "./liveAuth";
const { userInfoKey, speedBoatList, speedBoats, siteUser: { CORE, GUEST, WEB } } = Constants

class System {
  static getCoockieObjVal(key) {
    const avUserInfo = liveAuth.getAvUserInfo() ? liveAuth.getAvUserInfo() : { "firstName": null, "lastName": null, "phoneNumber": null, "speedboat": speedBoats.abacusAbbr, "userID": null, "email": null }
    let value = "";

    switch (key) {
      case userInfoKey.USERNAME:
        value = avUserInfo.firstName ? avUserInfo.firstName + ' ' + avUserInfo.lastName : "";
        break;
      case userInfoKey.SPEEDBOATNAME:
        value = avUserInfo.speedboat === speedBoats.ebvAbbr ? speedBoats.EBV : avUserInfo.speedboat === speedBoats.silicaAbbr ? speedBoats.SILICA : speedBoats.ABACUS
        break;
      case userInfoKey.SPEEDBOAT:
        value = avUserInfo[key] ? avUserInfo[key] : speedBoats.abacusAbbr;
        break;
      default:
        if (key === userInfoKey.BILLCOUNTRYCODE || key === userInfoKey.ACCOUNTNAME || key === userInfoKey.ACCOUNTNUMBER || key === userInfoKey.ROLES || key === userInfoKey.SALESORG || key === userInfoKey.ORDERBLOCK || key === userInfoKey.CREDITRISK) {
          value = avUserInfo?.account && avUserInfo?.account[key] !== undefined ? avUserInfo.account[key] : '';
        } else {
          value = avUserInfo[key] ? avUserInfo[key] : '';
        }
        break;
    }

    return value;
  }
  static avUserInfoData = {
    speedBoatAbbr: this.getCoockieObjVal(userInfoKey.SPEEDBOAT),
    speedBoatName: this.getCoockieObjVal(userInfoKey.SPEEDBOATNAME),
    speedBoatNameLower: this.getCoockieObjVal(userInfoKey.SPEEDBOATNAME)?.toLowerCase(),
    userName: this.getCoockieObjVal(userInfoKey.USERNAME),
    accountNumber: this.getCoockieObjVal(userInfoKey.ACCOUNTNUMBER),
    email: this.getCoockieObjVal(userInfoKey.EMAIL),
    accountName: this.getCoockieObjVal(userInfoKey.ACCOUNTNAME),
    roles: this.getCoockieObjVal(userInfoKey.ROLES),
    salesOrg: this.getCoockieObjVal(userInfoKey.SALESORG),
    orderBlock: this.getCoockieObjVal(userInfoKey.ORDERBLOCK),
    userType: liveAuth.getAvUserInfo() ? this.getCoockieObjVal(userInfoKey.ACCOUNTNUMBER) ? CORE : WEB : GUEST,
  };

  static getParams(url = window.location) {
    let params = {};
    new URL(url).searchParams.forEach(function (val, key) {
      if (params[key] !== undefined) {
        if (!Array.isArray(params[key])) {
          params[key] = [params[key]];
        }
        params[key].push(val);
      } else {
        params[key] = val;
      }
    });
    return params;
  }

  // Need to move to helper
  static camelToUnderscore(s) {
    return s
      .replace(/\.?([A-Z])/g, function (x, y) {
        return "_" + y.toLowerCase();
      })
      .replace(/^_/, "");
  }

  // Need to move to helper
  static anythingToCamel(str) {
    if (str === undefined) {
      return false;
    }
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  // Need to move to helper
  static getTheKeyForThisAPIMaker(key) {
    let k = System.snakeToCamel(System.camelToUnderscore(key));
    k = k.replaceAll("_", "");
    k = k.toLowerCase();
    return k;
  }

  // Need to move to helper
  static camelToDash(s) {
    return s.replace(
      /[A-Z]/g,
      (match, offset) => (offset > 0 ? "-" : "") + match.toLowerCase()
    );
  }

  // Need to move to helper
  static snakeToCamel = (str) =>
    str
      .toLowerCase()
      .replace(/([-_][a-z])/g, (group) =>
        group.toUpperCase().replace("-", "").replace("_", "")
      );

  static popup(popup_name, data = []) {
    require("./system/popup").Popup.dispatchIt(popup_name, data);
  }

  static alert(
    content,
    type = "success",
    errorModule = "",
    do_not_auto_focus = false
  ) {
    require("./system/popup").Popup.systemAlert(
      content,
      type,
      errorModule,
      do_not_auto_focus
    );
  }

  static toast(content, type = "success") {
    toast[type](content, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  static clearAllAlert() {
    require("./system/popup").Popup.clearAllAlert();
  }

  static auth(key = false) {
    System.setWindow_avUserInfo_cookie_name();
    let a = {};
    let avUserInfo = this.avUserInfoForAPI(false);
    if (avUserInfo && Object.entries(avUserInfo).length > 0) {
      a = avUserInfo;
    } else {
      a = Auth.defaultGuestAuth();
    }
    if (a.account !== undefined) {
      a = { ...a, ...a.account };
    }
    if (key) {
      let res_value = "";
      if (a[key] !== undefined) {
        res_value = a[key];
      }
      if (key === "roles") {
        res_value = this.authRolesForPermissions(res_value, a);
      }
      return res_value;
    }
    return a;
  }

  static authRolesForPermissions(res_value = [], processed_auth) {
    System.setWindow_avUserInfo_cookie_name();
    if (!res_value) {
      res_value = [];
    }
    if (!isArray(res_value)) {
      res_value = [];
    }
    const avUserInfo = liveAuth.getAvUserInfo()
    if (!avUserInfo) {
      res_value.push("GUEST");
    } else {
      if (processed_auth.account === undefined || !processed_auth?.account?.roles || (processed_auth?.account?.roles && Object.entries(processed_auth.account.roles).length === 0)) {
        res_value.push("AUTH_ACCOUNT_LESS");
      }
    }
    return res_value;
  }

  static avUserInfoForAPI(getString = true) {
    System.setWindow_avUserInfo_cookie_name();
    let a = {};
    const avUserInfo = liveAuth.getAvUserInfo()
    if (avUserInfo) {
      a = avUserInfo;
    }
    if (a.account === undefined || Object.entries(a.account).length === 0 || Object.entries(a).length === 0) {
      a = {
        ...a,
        account: { speedBoat: this.getCurrentSiteSpeedboatShortName() },
      };
    }
    if (getString) {
      return JSON.stringify(a);
    }
    return a;
  }

  // Need to update with new constant //  this.avUserInfoData.speedBoatName;
  static siteName() {
    return this.getCurrentSiteSpeedboat();
  }

  static getHomepageUrl() {
    return HCLDX.baseURL();
  }

  static getLoginPageUrl(isAuthAccLess = false) {
    if (isAuthAccLess !== undefined && isAuthAccLess !== null && isAuthAccLess === true) {
      return this.getAuthAccountLessURL(this.siteName());
    }
    return this.getRedirectionURL("/authenticate/login/");
  }

  // need to move to the helper
  static onEnterKeyPress(e) {
    if (e.which === 13) {
      return true;
    }
  }

  static setWindow_avUserInfo_cookie_name() {
    if (Cookies.get("selectedCurrency" + Helper.capitalizeFirstLetter(this.getCurrentSiteSpeedboat()))
    ) {
      window.mct = Cookies.get("selectedCurrency" + Helper.capitalizeFirstLetter(this.getCurrentSiteSpeedboat()));
      window.mcs = getSymbolFromCurrency(window.mct);
    }
  }

  static getAuthAccountLessURL(siteName) {
    let authAccURL = "/resources/forms/request-terms-account/";
    return this.getRedirectionURL(authAccURL);
  }

  static getRedirectionURL = (url) => {
    let _url = "";
    let baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    let sBoat = this.avUserInfoData.speedBoatNameLower;

    if (baseUrl && baseUrl.trim() && sBoat && sBoat.trim() && url) {
      // Check Speedboat URL and this works for NPI and other content tabs
      if (url.includes(sBoat)) {
        let count = (url.match(new RegExp(sBoat, 'g')) || []).length;
        // let splitTxt = count > 1 ? `${sBoat}/` : sBoat;
        sBoat = count > 1 ? `${sBoat}/` : sBoat;

        let splitUrlArr = url.split(sBoat);
        if (splitUrlArr && splitUrlArr.length > 0) {
          url = splitUrlArr[1];
        }
      }
      _url = baseUrl + sBoat + url;
    }
    return _url;
  };

  static getCurrentSpeedBoatUrl = (url) => {
    url = url.startsWith('/') ? url : `/${url}`
    return HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + this.getCurrentSiteSpeedboat() + url;
  }

  // Need to update with new constant // this.avUserInfoData.speedBoatAbbr; 
  static getRoHSURL = () => {
    let sBoat = this.getCurrentSiteSpeedboat();
    const sUrl = {
      abacus: '/about-us/about-avnet-abacus/environmental-sustainability/',
      silica: '/about-us/about-avnet-silica/environmental/',
      ebv: '/about-us/about-ebv-elektronik/social-leadership/'
    }
    return this.getCurrentSpeedBoatUrl(sUrl[sBoat]);
  }

  static getCurrentAvuserInfoCookie = () => {
    const avUserInfoFromCookie = encodeURI(liveAuth.getAvUserInfoString())
    if (
      (avUserInfoFromCookie &&
        (avUserInfoFromCookie === "{}" || avUserInfoFromCookie === "")) ||
      !avUserInfoFromCookie
    ) {
      let a = {};
      let fake_account = { speedBoat: this.getCurrentSiteSpeedboatShortName() };
      a = { ...a, account: fake_account };
      return JSON.stringify(a);
    } else {
      return avUserInfoFromCookie;
    }
  };

  /**common function for get speedboat #Hardik Sarodiya */
  // Need to update with new constant // this.avUserInfoData.speedBoatAbbr; 
  static getCurrentSiteSpeedboat = () => {
    var tempSpeedboat = "abacus";
    if (window.avnet && window.avnet.siteId !== undefined) {
      tempSpeedboat = window.avnet.siteId.toLowerCase();
    } else {
      var url = window.location.href;
      if (url.indexOf("ebv") !== -1) {
        tempSpeedboat = "ebv";
      } else if (url.indexOf("silica") !== -1) {
        tempSpeedboat = "silica";
      }
    }
    return tempSpeedboat.toLowerCase();
  };

  /** common function which will return speedboat short name #Pankaj Nihalani   */
  // Need to update with new constant // this.avUserInfoData.speedBoatAbbr; 
  static getCurrentSiteSpeedboatShortName = () => {

    let speedBoat = this.getCurrentSiteSpeedboat();
    if (speedBoat === "abacus") {
      return "T";
    }
    if (speedBoat === "ebv") {
      return "B";
    }
    if (speedBoat === "silica") {
      return "S";
    }
  };

  // static getCurrentAccountEmailBySpeedboat = () => {
  //   const avUserInfo = liveAuth.getAvUserInfo()
  //   if (avUserInfo) {
  //     return avUserInfo?.email;
  //   }
  // };

  /** 11694-  Common Function for getting order block flag from the cookie - Pankaj - 21 Dec,2023   */
  static getOrderBlockCreditRiskFlagBySpeedboat = () => {
    let obj = {
      isCreditRisk: false,
      isOrderBlock: false
    }
    const accountObj = this.auth('account');
    if (isObject(accountObj) && Object.keys(accountObj).length > 0) {
      obj.isCreditRisk = accountObj?.creditRisk === true;
      obj.isOrderBlock = accountObj?.orderBlock === true;
    }
    return obj;
  }

  // Need to update with new constant //  this.avUserInfoData.speedBoatName; 
  static getSpeedBoatName = () => {
    const speedBoat = System.auth('speedBoat') === 'T' ? 'Abacus' : System.auth('speedBoat') === 'B' ? 'EBV' : 'Silica'
    return speedBoat
  }

  // Need to update with new constant //  this.avUserInfoData.speedBoatName; 
  static getPrivacyPageUrl() {
    let siteName = this.siteName()
    let authAccURL = "";
    switch (siteName.toUpperCase()) {
      case "EBV":
        authAccURL = "/about-us/footer/privacy-statement/";
        break;
      case "SILICA":
        authAccURL = "/about-us/footer/privacy-statement/";
        break;
      default:
        authAccURL = "/about-us/privacy-statement/";
        break;
    }
    return this.getRedirectionURL(authAccURL);
  }
  static getTermsAndConditionPageUrl() {
    const baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    const _url = baseUrl + 'emea/about-us/terms-and-conditions-of-sale';
    return _url
  }
  static getHelpPageUrl() {
    return this.getCurrentSiteSpeedboat() === speedBoats.abacus ? this.getRedirectionURL("/about-us/locations-contact-us/") : this.getRedirectionURL("/about-us/locations-contacts/")
  }
  static getPreviousPageUrl() {
    let _url = "";
    let baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    let sBoat = this.siteName();
    if (baseUrl && baseUrl.trim() !== "" &&
      sBoat && sBoat.trim() !== ""
    ) {
      _url = baseUrl + sBoat
    }
    return _url
  }

  // Need to update with new constant //  this.avUserInfoData.speedBoatName; 
  static getSpeeBboat() {
    const speedBoat = System.auth('speedBoat') === 'T' ? Constants.MYAVNET.ABACUS : System.auth('speedBoat') === 'B' ? Constants.MYAVNET.EBV : Constants.MYAVNET.SILICA
    return speedBoat
  }

  // Need to update with new constant //  this.avUserInfoData.speedBoatName; 
  static getDataProtectionPolicy() {
    let siteName = this.siteName()
    let authAccURL = "";
    const baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    switch (siteName.toUpperCase()) {
      case "EBV":
        authAccURL = `${baseUrl}ebv/about-us/footer/privacy-statement/`;
        break;
      case "SILICA":
        authAccURL = `${baseUrl}silica/about-us/footer/privacy-statement/`;
        break;
      default:
        authAccURL = `${baseUrl}abacus/about-us/privacy-statement/`;
        break;
    }
    return authAccURL
  }

  // Need to update with new constant //  this.avUserInfoData.speedBoatName; 
  static getFarnellCMPUrl() {
    let siteName = this.siteName()
    let CMPUrl = ""
    CMPUrl = siteName === 'abacus' ? 'ABACUS-AVNET-BOM-DESIGNHUB-FARNELL' : siteName === 'ebv' ? 'EBV-AVNET-BOM-DESIGNHUB-FARNELL' : 'SILICA-AVNET-BOM-DESIGNHUB-FARNELL'
    return CMPUrl
  }

  static getSpeedboatURL(sBoat) {
    if (sBoat) {
      return HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + sBoat.toLowerCase();
    }
    return '';
  }
  static checkPriceValues(pricingList) {
    let isPriceVal = Object.keys(pricingList).length;
    let userAcctVal = (window?.avUserInfoJS) && JSON.parse(window?.avUserInfoJS);
    let avUserAccObj = userAcctVal?.account;
    if (avUserAccObj && Object.keys(avUserAccObj).length && isPriceVal) {
      return true;
    }
    else if (!avUserAccObj) {
      return true;
    }

  }

  static CheckInternalUser = () => {
    let r = this.auth('roles');
    if (r.includes('ZX') || r.includes('ZU') || r.includes('AUTH_ACCOUNT_LESS')) {
      return false
    } else {
      return true
    }
  }

  static getFarnellURL() {
    return process.env.REACT_APP_FARNELL_URL;
  }

  static isAdminUserLastLoginDateSearchEnabled() {
    const flag = process.env.REACT_APP_ENABLE_ADMIN_USER_LAST_LOGIN_DATE_SEARCH;
    return ['1', 'true', 'yes'].includes((flag || '').toLowerCase());
  }

  static storageName = {
    // local storage variables
    UNIVERSAL_SEARCH: 'universal_search'
  }
}

export default System;
